exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1ypT2{position:relative;background-color:#fff;padding:2px 10px 0;min-height:240px;border-bottom:1px solid #d8d8d8;-webkit-box-shadow:0 2px 4px rgba(0,0,0,.12);box-shadow:0 2px 4px rgba(0,0,0,.12);-webkit-transition:all .1s ease-out;-o-transition:all .1s ease-out;transition:all .1s ease-out}._153Wb{font-size:18px;font-weight:700;display:inline-block;padding:6px 3px 10px;color:#000}._3E5xn{padding:0!important}.lLjHT{width:232px}._1jZmI{padding-bottom:10px}.riRUN{padding-bottom:0}.riRUN>div{padding-bottom:10px}", ""]);

// exports
exports.locals = {
	"root": "_1ypT2",
	"best": "_153Wb",
	"advertThumbItem": "_3E5xn",
	"advertItem": "lLjHT",
	"header": "_1jZmI",
	"carouselBody": "riRUN"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/TopCars/TopCars.css
// module id = 2868
// module chunks = 20